import { Component, OnInit, Input,  Output, EventEmitter } from '@angular/core';
import {ReportsService} from "../../report-components/reports.service";
import * as _ from "lodash";
import {MatTableDataSource} from "@angular/material/table";

@Component({
  selector: 'app-cagad-select',
  templateUrl: './cagad-select.component.html',
  styleUrls: ['./cagad-select.component.css']
})
export class CagadSelectComponent implements OnInit {

  /*
  https://docs.angular.lat/guide/inputs-outputs
  https://codehandbook.org/refresh-child-angular/

  parent:
        [] input
        () output

        <app-cagad-select
          *ngIf="network_id"
          [hide_adgroups]=false
          [hide_ads]=false
          [account_id]="account_id"
          [start_date]="start_date"
          [end_date]="end_date"
          [network_id]="network_id"
          (newItemEventCampaign)= "selectCagadValueCampaign($event)"
          (newItemEventAdgroup)= "selectCagadValueAdgroup($event)"
          (newItemEventAd)= "selectCagadValueAd($event)">
        </app-cagad-select>



        TypeScript - Place in Compomenent that uses the reusable component
          network_id: string = null;
          selectValueNetwork(value) {
            this.network_id = value;
            console.log('network_id from parent:',this.network_id)
          }

          campaign_id: string = null;
          selectCagadValueCampaign(value){
            this.campaign_object = value;
            console.log('campaign_id from parent:',this.campaign_object)
            //{
            //     "campaign_id": "23847420755750699",
            //     "campaign_name": "A | BOFU | Conversions"
            // }
          }

          adgroup_id: string = null;
          selectCagadValueAdgroup(value){
            this.adgroup_object = value;
            console.log('adgroup from parent:',this.adgroup_object)
            // {
            //     "adgroup_id": "23848135267380699",
            //     "adgroup_name": "WW:(A-PUR):ATC 60D:[A]:7C1V:18-65+"
            // }
          }

          ad_id: string = null;
          selectCagadValueAd(value){
            this.ad_object = value;
            console.log('ad from parent:',this.ad_object)
            // {
            //     "ad_id": "23849798639720699",
            //     "ad_name": "[Video] MRR Hook ID 2081330698712120 – Copy - Copy 2"
            // }
          }



  */

  is_loading = false;
  @Input() agency_id = '';
  @Input() account_id = '';
  @Input() network_id = '';  // e.g. facebok || googleads
  //DATE FORMAT: yyyy-MM-dd
  @Input() start_date = '';
  @Input() end_date = '';

  @Input() hide_adgroups = false;
  @Input() hide_ads = false;

  @Output() newItemEventCampaign = new EventEmitter<any>();
  @Output() newItemEventAdgroup = new EventEmitter<any>();
  @Output() newItemEventAd = new EventEmitter<any>();

  cagad_campaign_object = [];
  cagad_adgroup_object = [];
  cagad_ad_object = [];
  x_body = {};
  campaign_id: string = null;
  adgroup_id: string = null;
  ad_id: string = null;

  campaign_id_name_lookup = {}
  adgroup_id_name_lookup = {}
  ad_id_name_lookup = {}

  adgroup_adset_name:string = 'Adgroup';

  constructor(private reportService: ReportsService) { }

  ngOnInit(): void {

    this.loadData()
  } //end ngOnInit

  loadData() {

    if (this.network_id == 'facebook') {
      this.adgroup_adset_name = 'Adset'
    }
    else if (this.network_id == 'googleads') {
      this.adgroup_adset_name = 'Adgroup'
    }

    this.x_body = {};
    this.cagad_campaign_object = []; //reset campaign on network change
    this.cagad_adgroup_object = []; //reset adgroup on network change
    this.cagad_ad_object = [];
    this.campaign_id_name_lookup = {}
    this.adgroup_id_name_lookup = {}
    this.ad_id_name_lookup = {}

    this.is_loading = true;
    let endpoint = `reports?rt=network_campaign_meta&account_id=${this.account_id}&start_date=${this.start_date}&end_date=${this.end_date}&network=${this.network_id}`;
    let fu = this.reportService.get(endpoint).subscribe(x => {
        if (_.isEmpty(x['body'])) {
          console.log('empty')
          this.is_loading = false;
        } else {
          let x_body = x['body']
          this.selectCampaignObject(x_body);
        } //end x['body] if
      }, error => {
        this.is_loading = false;
      } // end error
    ); //end reportService.get

  } //end loadData

  selectCampaignObject(x){
    this.x_body = x
    Object.entries(x['campaigns']).forEach(([k,v]) => {
      this.campaign_id_name_lookup[k] = v['campaign_name'];
      this.cagad_campaign_object.push({name: v['campaign_name'], id: k})
    }) //end object.entries

    this.is_loading = false;

  } //end selectCampaignObject

  selectCampaignEvent(event){
    this.cagad_ad_object = []; //reset ad on campaign change
    this.cagad_adgroup_object = []; //reset adgroup on campaign change
    this.adgroup_id_name_lookup = {};
    this.ad_id_name_lookup = {};

    this.adgroup_id = null;
    this.campaign_id = event.value;
    console.log(this.x_body['campaigns'][this.campaign_id]['adgroups'])
    console.log('select campaign_id from reusable',this.campaign_id)

    let temp = {'campaign_id': this.campaign_id, 'campaign_name': this.campaign_id_name_lookup[this.campaign_id]}
    this.newItemEventCampaign.emit(temp);

    this.cagad_adgroup_object = this.x_body['campaigns'][this.campaign_id]['adgroups']

    for (var _i = 0; _i < this.cagad_adgroup_object.length; _i++) {
      this.adgroup_id_name_lookup[this.cagad_adgroup_object[_i]['id']] = this.cagad_adgroup_object[_i]['name'];
    } //end loop

  } //end selectCampaignEvent

  selectAdgroupEvent(event){
    this.cagad_ad_object = [];
    this.ad_id_name_lookup = {};

    this.adgroup_id = null;
    this.adgroup_id = event.value;
    console.log('from child select',this.adgroup_id)


    this.cagad_ad_object = this.x_body['adgroups'][this.adgroup_id]['ads']
    console.log('this.cagad_ad_object',this.cagad_ad_object)
    for (var _i = 0; _i < this.cagad_ad_object.length; _i++) {
      this.ad_id_name_lookup[this.cagad_ad_object[_i]['id']] = this.cagad_ad_object[_i]['name'];
    } //end loop

    let temp = {'adgroup_id': this.adgroup_id, 'adgroup_name': this.adgroup_id_name_lookup[this.adgroup_id]}
    this.newItemEventAdgroup.emit(temp);

  } //end selectAdgroupEvent

  selectAdEvent(event){

    this.ad_id = event.value;
    console.log('from child select ad_id',this.ad_id)

    let temp = {'ad_id': this.ad_id, 'ad_name': this.ad_id_name_lookup[this.ad_id]}
    this.newItemEventAd.emit(temp);

  } //end selectAdgroupEvent

  ngOnChanges(){
    console.log('ngOnChanges network_id',this.network_id)
    this.loadData()
  }

}
